/*
  Sunpatch enhancements. Progressive: the page works without this file.
  1. Keeps "Fabric: Shell" style labels in sync with the selected option.
  2. Reveals section headings once as they enter the viewport (only when motion is enabled
     in theme settings and the visitor has not asked for reduced motion).
*/
(() => {
  const syncSelectedValue = (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
    const fieldset = input.closest('fieldset');
    const label = fieldset?.querySelector('[data-selected-value]');
    if (label) label.textContent = input.value;
  };
  document.addEventListener('change', syncSelectedValue);

  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!root.hasAttribute('data-sp-motion') || reduceMotion.matches || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px' }
  );

  const watch = (scope = document) => {
    scope.querySelectorAll('.sp-reveal:not(.is-revealed)').forEach((el) => observer.observe(el));
  };

  root.classList.add('sp-motion-ready');
  watch();
  // Theme Editor: re-run when a section is added or re-rendered.
  document.addEventListener('shopify:section:load', (event) => watch(event.target));
})();
